import map from "lodash/map";
import toString from "lodash/toString";
import { utc } from "PFCore/helpers/date";
import useBookingCategories from "PFCore/hooks/use_booking_categories";
import { useBooleanToString } from "PFCore/hooks/use_boolean_to_string";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { useItemsEnumerate } from "PFCore/hooks/use_items_enumerate";
import { useTranslation } from "react-i18next";

import { ReadableAvailabilityRules } from "../readable_availability_rules";

export const useValueRenderer = () => {
  const { t } = useTranslation();
  const { formatDate, formatDateTime } = useDateFormatter();
  const enumerateItems = useItemsEnumerate();
  const { getBookingCategory } = useBookingCategories();
  const booleanToString = useBooleanToString();

  return {
    "custom_field": ({ value, separator = "\n" }) =>
      typeof value === "string"
        ? value
        : map(value, (data) =>
            data
              ? data.text || data.text === ""
                ? data.text
                : data.value || data.value === 0
                  ? data.value
                  : data
              : ""
          ).join(separator),
    "integer": ({ value }) => value.toString(),
    "toggle": ({ value, description }) => {
      const formattedValue = booleanToString(toString(value) === "true");
      return description ? `${description}: ${formattedValue}` : formattedValue;
    },
    "date": ({ value }) => formatDate(value),
    "date-time": ({ value }) => formatDateTime(utc(value)),
    "date-range": ({ value }) => `${formatDate(utc(value.start_date))} - ${formatDate(utc(value.end_date))}`,
    "date-range-with-current": ({ value }) =>
      `${formatDate(utc(value.start_date))} - ${formatDate(utc(value.end_date))}`,
    "availability": ({ value }) => <ReadableAvailabilityRules availability={value} />,
    "booking_category_id": ({ value }) => getBookingCategory(value)?.display_as || "",
    "checkboxes": ({ value }) => {
      const selectedValues = value.filter(({ value }) => value).map(({ id }) => t(id, { defaultValue: id }));

      return enumerateItems(selectedValues);
    }
  };
};
